module.exports = __webpack_public_path__ + "media/images/photos/24-7b25a579dedfffd2f8dc92c23017a781.jpg";